import { Component, NgModule } from "@angular/core";
import { StoreService } from "./services/store/store.service";
import { ActivatedRoute } from "@angular/router";
import { GlobalService } from "./services/global.service";
import { NavController } from "@ionic/angular";

@NgModule({})
export class CheckInLayoutModule {
  // This module is intentionally left empty.
  // It serves as a placeholder for the CheckIn layout functionality.
}

@Component({
  template: `<ng-content></ng-content>`,
})
export class CheckInLayoutComponent {
  constructor(
    private storeService: StoreService,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private navController: NavController,
  ) {
    this.route.params.subscribe((params) => {
      const storeID = params["storeID"];
      if (storeID) {
        this.globalService.showLoading();
        this.storeService
          .storeCheckIn(storeID)
          .then((res) => {
            console.log(res);
            // if (res.startAction == "only-menu") {
            //   location.href = `https://m.orwi.app/?storeId=${res.store.id}`;
            // }
          })
          .catch((err) => {
            console.error(err);
            navController.navigateRoot("/");
          })
          .finally(() => {
            this.globalService.closeLoading();
          });
      }
    });
  }
  // This component is intentionally left empty.
  // It serves as a placeholder for the CheckIn layout functionality.
}
